import { useAuthGuardedMutation } from "@/hooks/useAuthGuardedMutation";

import { MediaApi } from "./media.api";

export namespace MediaQueries {
  export const useGetPresignedUrl = () => {
    return useAuthGuardedMutation({
      mutationFn: MediaApi.getPresignedUrl,
    });
  };

  export const useUploadPut = () => {
    return useAuthGuardedMutation({
      mutationFn: MediaApi.uploadPut,
    });
  };

  export const useUploadPost = () => {
    return useAuthGuardedMutation({
      mutationFn: MediaApi.uploadPost,
    });
  };
}
